export default __webpack_public_path__ + "static/media/plain-sticker-y.a536cc15.png";